import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';

import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class OnHoldOrderFeature implements IFlagFeature {
  name = Features.ON_HOLD_ORDER;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
